// @flow
import { useContext } from 'react';
import SelectionDataContext from './SelectionDataContext';

const useSelectionData = () => useContext(SelectionDataContext);
export default useSelectionData;
